import { graphql } from "react-relay";

export const QUERY = graphql`
	query reportsTableFilters_Query {
		Viewer {
			Reports {
				SystemEmail
			}
		}
	}
`;
